<script>
    import LyInputText from '../forms/LyInputText.svelte';
    import LyInputPassword from '../forms/LyInputPassword.svelte';
    import LyButtons from '../forms/LyButtons.svelte';
    import LyHeader from '../components/LyHeader.svelte';
    import LyButton from '../forms/LyButton.svelte';
    import LyFieldset from '../forms/LyFieldset.svelte';
    import LyForm from '../forms/LyForm.svelte';
    import { MessageStore } from '../../stores/MessageStore.svelte.js';
    import { UserStore } from '../../stores/UserStore.svelte.js';
    import LyHeadline from '../components/LyHeadline.svelte';

    /**
     * @type {{
     *     user?: string,
     *     password?: string,
     *     openRegister?: () => void,
     *     openNewPassword?: () => void
     * }}
     */
    let { user = '', password = '', openRegister = () => {}, openNewPassword = () => {} } = $props();

    /** @type {HTMLInputElement|null} */
    let passwordInput = $state(null);
    let disableForm = $state(false);

    async function tryLogin() {
        disableForm = true;

        // -
        user = user.trim();
        const usePassword = password.trim();
        password = '';

        // -
        if (user === '' || usePassword === '') {
            if (user === '' && usePassword === '') {
                MessageStore.error('Bitte den Login und Passwort eingeben.');
            } else if (user === '') {
                MessageStore.error('Bitte den Login eingeben.');
            } else if (usePassword === '') {
                MessageStore.error('Bitte das Passwort eingeben.');
            }
            disableForm = false;
            return;
        }

        // -
        const isLoggedIn = await UserStore.doLogin(user, usePassword);
        if (isLoggedIn) {
            user = '';
        } else {
            disableForm = false;
        }
    }
</script>

<LyHeader>
    <LyHeadline>Anmeldung</LyHeadline>
</LyHeader>
<LyForm mt="4" tag="div">
    <LyFieldset border={false}>
        <LyInputText
            name="user"
            required={true}
            label="Login"
            placeholder="Benutzername oder E-Mail"
            autocomplete={true}
            autofocus={true}
            bind:value={user}
            onkeydown={(/** @type {KeyboardEvent} */ e) => e.key === 'Enter' && passwordInput?.focus()} />
        <LyInputPassword
            name="password"
            required={true}
            label="Passwort"
            placeholder=""
            bind:thisRef={passwordInput}
            bind:value={password}
            onkeydown={(/** @type {KeyboardEvent} */ e) => e.key === 'Enter' && tryLogin()} />
    </LyFieldset>

    <LyButtons>
        <LyButton label="Login" disabled={disableForm} onclick={tryLogin} />
    </LyButtons>

    <LyButtons mt={true}>
        <LyButton label="Passwort?" color={true} onclick={openNewPassword} />

        <LyButton label="Kein Konto?" color={true} onclick={openRegister} />
    </LyButtons>
</LyForm>
